import { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";

export const PharmacyModal = ({
  pharmacyText,
  setPharmacyText,setSelectedPharma,
  pharmacySuggestions,
  setPharmacySuggestions,
  isPharmacySelected,
  setIspharmacySelected,
  updatePharmacy,
  visibleInputIndex,
  respdata,
  onClose,
  fetchPharmacySuggestions,
}) => {
  const [debouncedText, setDebouncedText] = useState(pharmacyText);

  const canUpdate = (pharmacyText || "").trim().length > 0;

  // Debounce logic
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedText(pharmacyText);
    }, 400); // adjust delay as needed

    return () => {
      clearTimeout(handler);
    };
  }, [pharmacyText]);

  // Fetch suggestions when debounced text changes
  useEffect(() => {
    if (debouncedText && !isPharmacySelected) {
      fetchPharmacySuggestions(debouncedText);
    } else {
      setPharmacySuggestions([]);
    }
  }, [debouncedText, isPharmacySelected,  setPharmacySuggestions]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="relative w-[640px] max-w-full rounded-2xl bg-white p-6 md:p-8 shadow-2xl">
        {/* Close */}
        <button
          onClick={onClose}
          className="absolute right-4 top-4 inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0B1223] hover:bg-gray-100"
          aria-label="Close"
        >
          ✕
        </button>

        <h3 className="text-[19px] font-semibold text-[#1E2939] font-inter mb-2 text-left">
          Find Your Pharmacy
        </h3>
        <p className="text-[14px] text-[#4A5565] font-inter mb-6 text-left">
          Search by pharmacy name to find a pharmacy near you.
        </p>

        <div className="mb-6">
          <div className="relative">
            <span className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-[#9AA4B2]">
              <SearchIcon />
            </span>
            <input
              className="w-full rounded-xl border border-[#E5E7EB] pl-11 pr-4 py-3 text-[#111827] placeholder-[#9AA4B2] outline-none focus:ring-4 focus:ring-[#155DFC]/20 focus:border-[#155DFC] transition"
              placeholder="Enter pharmacy name"
              value={pharmacyText}
              onChange={(e) => {
                setPharmacyText(e.target.value);
                setIspharmacySelected(false); // allow re-search if typing again
              }}
            />
          </div>

          {/* Suggestions */}
          {pharmacyText &&
            !isPharmacySelected &&
            pharmacySuggestions.length > 0 && (
              <ul className="mt-2 max-h-48 overflow-y-auto rounded-xl border text-start border-[#E5E7EB]">
                {pharmacySuggestions.map((s, idx) => (
                  <li
                    key={idx}
                    onClick={() => {
                      setPharmacyText(s.name);
                      setPharmacySuggestions([]); // clear list
                      setIspharmacySelected(true);
                      setSelectedPharma(s)
                    }}
                    className="cursor-pointer px-4 py-2 text-sm hover:bg-gray-50"
                  >
         <span className="font-medium text-gray-900">{s.name}</span>
  <span className="text-gray-500 ml-2 text-xs">
    {s.city}{s.city && s.zipcode ? ", " : ""}{s.zipcode}
  </span>
                  </li>
                ))}
              </ul>
            )}
        </div>

        <div className="mt-4 flex items-center justify-end gap-3">
          <button
            onClick={() => {
              setPharmacyText("");
              setPharmacySuggestions([]);
              setIspharmacySelected(false);
              onClose();
            }}
            className="h-11 rounded-xl border border-[#E5E7EB] bg-white font-inter px-6 text-sm text-[#4A5565] hover:bg-gray-50"
          >
            Cancel
          </button>

          <button
            onClick={() => {
              if (!canUpdate) return;
              updatePharmacy({
               
              });
              onClose();
            }}
            disabled={!canUpdate}
            className={`h-11 rounded-xl px-6 text-sm text-white font-inter transition ${
              canUpdate
                ? "bg-[#2B7FFF]"
                : "bg-[#155DFC]/60 cursor-not-allowed"
            }`}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
};
